/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AvatarFromJSON, AvatarToJSON } from './Avatar';
export function SendedByFromJSON(json) {
    return SendedByFromJSONTyped(json, false);
}
export function SendedByFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        displayName: !exists(json, 'display_name') ? undefined : json['display_name'],
        avatar: !exists(json, 'avatar') ? undefined : AvatarFromJSON(json['avatar'])
    };
}
export function SendedByToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        display_name: value.displayName,
        avatar: AvatarToJSON(value.avatar)
    };
}
